export const arrayRange = (size: number): number[] => [...Array(size)];
